<app-loader></app-loader>
<router-outlet [dir]="currentDir"></router-outlet>
<app-auth-modal></app-auth-modal>

<!-- Waseel Chat Widget - Available on all pages -->
<waseel-widget-loader 
  [environment]="'production'" 
  [delay]="500">
</waseel-widget-loader>
